export var Audience;
(function (Audience) {
    Audience["WEB"] = "WEB";
    Audience["IOS"] = "IOS";
    Audience["ANDROID"] = "ANDROID";
})(Audience || (Audience = {}));
export var ExitPointType;
(function (ExitPointType) {
    ExitPointType["REDIRECT"] = "REDIRECT";
    ExitPointType["MESSAGE"] = "MESSAGE";
})(ExitPointType || (ExitPointType = {}));
